var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 337L196 365",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.5,
    cy: 332.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.987 332.19C191.987 328.283 195.288 325.117 199.358 325.117C199.943 325.117 200.511 325.184 201.056 325.308C199.742 324.48 198.187 324 196.519 324C191.814 324 188 327.806 188 332.5C188 337.194 191.814 341 196.519 341C198.814 341 200.895 340.093 202.427 338.62C201.492 339.032 200.454 339.263 199.358 339.263C195.288 339.263 191.987 336.096 191.987 332.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.402 331.6L205.37 329.146L203.536 330.719L201.304 330.056L202.112 332.337L200.765 334.381L203.1 334.218L204.499 336.144L205.133 333.763L207.345 332.909L205.402 331.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.2b25b8458a8762c4f9e8d28924579687.svg";
export { ForwardRef as ReactComponent };